import { useI18n } from 'hooks/useI18n';
import {
  StyledHero,
  StyledHeroContainer,
  StyledHeroShootingStar,
  StyledHeroStars,
  StyledHeroText,
  StyledHeroTitle
} from './JoinUsHero.styled';

const JoinUsHero: React.FC = () => {
  const { t } = useI18n('join-us');

  return (
    <StyledHero>
      <StyledHeroStars>
        <div>
          <StyledHeroShootingStar />
          <StyledHeroShootingStar />
          <StyledHeroShootingStar />
          <StyledHeroShootingStar />
          <StyledHeroShootingStar />
        </div>
      </StyledHeroStars>
      <StyledHeroContainer>
        <StyledHeroText>
          <StyledHeroTitle editorial>{t('join.title')}</StyledHeroTitle>
          <p>{t('join.desc')}</p>
          <p className="cta">
            <strong>{t('join.cta')}</strong>
          </p>
        </StyledHeroText>
      </StyledHeroContainer>
    </StyledHero>
  );
};

export default JoinUsHero;
